<template>
    <div class="zhineng-header2">
        <div>
            <img src="@/assets/image/zhineng.png" alt="" style="width:100%;margin-top: 80px">
        </div>
        <div>
            <div class="container" >
                <div class="header-first5" style="margin-top: 60px;">
                <div ref="slideUpDiv" >
                    <div style="border-bottom: 4px solid #2169F9; width: 115px;">
                       <span style="font-size: 28px; color: #000000; padding-top: 10px;">分体终端</span>
                    </div>
                    <div style="display: flex;margin-top: 40px;" >
                    <div class="lang" style="display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 10px 21px 0px rgba(228, 240, 255,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z1.png" alt="">
                        <p style="font-size: 24px;color: #000000;" class="slide-down">HD1400</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;" class="slide-down">多路高清视频输入输出，高性能终端</p>
                    </div>
                    <div  class="lang" style="margin-left: 28px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z2.png" alt="">
                        <p style="font-size: 24px;color: #000000;" class="slide-down">HD1200</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;" class="slide-down">4K高清终端，多屏输出和显示</p>
                    </div>
                    <div  class="lang" style="margin-left: 28px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z3.png" alt="">
                        <p style="font-size: 24px;color: #000000;" class="slide-down">HD1000</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;" class="slide-down">1080P高清终端，接口全面，双屏异显</p>
                    </div>
                    </div>
                </div>
                </div>
                <div class="header-first6" style="margin-top:60px;" >
                <div class="slide-down" ref="slideUpDiv1" >
                    <div style="border-bottom: 4px solid #2169F9; width: 255px;">
                       <span style="font-size: 28px; color: #000000; padding-top: 10px;">一体终端和桌面终端</span>
                    </div>
                    <div style="display: flex;margin-top: 20px;">
                        <div style="display: flex;margin-top: 20px;" >
                    <div  class="lang" style="display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z4.png" alt="">
                        <p style="font-size: 24px;color: #000000;">YT160</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;">1080P高清一体终端，广角拍摄</p>
                    </div>
                    <div    class="lang" style="margin-left: 28px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z5.png" alt="" >
                        <p style="font-size: 24px;color: #000000;">YT190</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;">4K一体AI终端，双屏双显</p>
                    </div>
                    <div  class="lang" style="margin-left: 28px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z6.png" alt="" >
                        <p style="font-size: 24px;color: #000000;">YT200</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;">1080P高清终端，接口全面，双屏异显</p>
                    </div>
                    </div>
                    </div>
                    <div  class="slide-down" >
                        <div class="lang" style="margin-top:30px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                            <img src="@/assets/image/z7.png" alt="" style="margin-top: 60px;">
                            <p style="font-size: 24px;color: #000000;">YT185</p>
                            <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;">桌面一体终端，体机轻便，带电池</p>
                        </div>
                       
                    </div>
                </div>
                </div>
                <div class="header-first7" style="margin-top:70px;" >
                <div class="slide-down" ref="slideUpDiv1" >
                    <div style="border-bottom: 4px solid #2169F9; width: 115px;">
                       <span style="font-size: 28px; color: #000000; padding-top: 10px;">智慧大屏</span>
                    </div>
                    <div style="display: flex;margin-top: 20px;">
                        <div style="display: flex;margin-top: 20px;" >
                    <div  class="lang" style="display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z8.png" alt="" style="margin-top: 60px;">
                        <p style="font-size: 24px;color: #000000;">Hub65</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;">内置音视频，一键开会</p>
                    </div>
                    <div    class="lang" style="margin-left: 28px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z8.png" alt="" style="margin-top: 60px;">
                        <p style="font-size: 24px;color: #000000;">Hub75</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;">接口可扩展，自带白板交互</p>
                    </div>
                    <div  class="lang" style="margin-left: 28px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z8.png" alt="" style="margin-top: 60px;">
                        <p style="font-size: 24px;color: #000000;">Hub85</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;">4K超高清显示，多功能使用</p>
                    </div>
                    </div>
                    </div>
                </div>
                </div>
                <div class="header-first8" style="margin-top:30px;" >
                <div class="slide-down" ref="slideUpDiv1" >
                    <div style="border-bottom: 4px solid #2169F9; width: 310px;">
                       <span style="font-size: 28px; color: #000000; padding-top: 10px;">高清摄像头和全向麦克风</span>
                    </div>
                    <div style="display: flex;margin-top: 20px;">
                        <div style="display: flex;margin-top: 20px;" >
                    <div  class="lang" style="display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z9.png" alt="" style="margin-top: 60px;">
                        <p style="font-size: 24px;color: #000000;">SP950</p>
                        <p style="font-size: 18px;color: #0B0306 !important;margin-top: 26px;">1080P高清广角摄像头</p>
                    </div>
                    <div    class="lang" style="margin-left: 28px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z10.png" alt="" style="margin-top: 60px;">
                        <p style="font-size: 24px;color: #000000;">SM100</p>
                        <p style="font-size: 18px;color: #0B0306 !important ;margin-top: 26px;">双目智能语音跟踪摄像头</p>
                    </div>
                    <div  class="lang" style="margin-left: 28px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                        <img src="@/assets/image/z11.png" alt=""   style="margin-top: 60px;">
                        <p style="font-size: 24px;color: #000000;">VX700</p>
                        <p style="font-size: 18px;color: #0B0306 !important ;margin-top: 26px;">4K 高清广角摄像头</p>
                    </div>
                    </div>
                    </div>
                    <div  class="slide-down" style="display: flex;">
                        <div class="lang" style="margin-top:30px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                            <img src="@/assets/image/z12.png" alt="" style="margin-top: 60px;">
                            <p style="font-size: 24px;color: #000000;">A10</p>
                            <p style="font-size: 18px;color: #0B0306 !important ;margin-top: 26px;">一拖二智能全向麦，覆盖范围广</p>
                        </div>
                        <div class="lang" style="margin-top:30px;margin-left: 28px;display: flex;flex-direction: column;align-items: center;;width: 397px !important; height: 443px; background: #FFFFFF; box-shadow: 5px 4px 21px 0px rgba(33,105,249,0.14); border-radius: 10px;">
                            <img src="@/assets/image/z13.png" alt="" style="margin-top: 60px;">
                            <p style="font-size: 24px;color: #000000;">I50</p>
                            <p style="font-size: 18px;color: #0B0306 !important ;margin-top: 26px;">全双工、自适应降噪</p>
                        </div>
                    </div>
                </div>
                </div>
  </div>
        </div>
    </div>
</template>

<script>
   export default {
 
};
</script>

<style lang="scss">
.container .lang{
    box-shadow: 2px 2px 10px 0px rgba(153, 199, 252, 0.3) !important;
    // box-shadow: 0 0 .52083vw rgba(0, 0, 0, .4) !important;
    cursor: pointer;
    transition: transform .3s ease;
}
.container .lang:hover{
        background: linear-gradient(0deg, #e4f0ff, #fff) no-repeat !important;
        transform: translateY(-10px); 
    }
    .zhineng-header2{
        .header-first3{
            height: s20px;
            width:1200px;
            margin:0 auto;
            margin-top: 30px;
        }
    .header-first4{
            height: 540px;
            width:1200px;
            margin:0 auto;
    }
    .header-first5{
            height: 510px;
            width:1200px;
            margin:0 auto;
            margin-top: 20px;
    }
    .header-first6{
            height: 980px;
            width:1200px;
            margin:0 auto;
            margin-top: 20px;
    }
    .header-first7{
            height: 560px;
            width:1200px;
            margin:0 auto;
            margin-top: 20px;
    }
    .header-first8{
            height: 1080px;
            width:1200px;
            margin:0 auto;
            margin-top: 20px;
    }
        width: 100%;
        .header-first{
            height: 710px;
            width:1200px;
            margin:0 auto;
        }
        .header-send{
            height: 690px;
            background: #EBF3FE;
        }
    }
    // .gaoliang .liang{
    //     box-shadow: 0 0 .52083vw rgba(0, 0, 0, .4);
    //     transition: transform .3s ease;
    // }
    //  .gaoliang .liang:hover{
    //     background: linear-gradient(0deg, #e4f0ff, #fff) no-repeat !important;
    //     transform: translateY(-10px); 
    // }
</style>